/**
 * Change #100336 - "when this user logs in the default page isn't this?"
 *
 * The page someone was on when their session ended is kept in localStorage
 * ("post_login_redirect") so signing back in returns them there, ahead of
 * their Default landing page. Nothing said WHOSE page it was or WHEN, so on a
 * shared browser the next person to sign in - or the same person a week
 * later - was sent to that leftover page instead of their landing page.
 *
 * Now the saved page carries the user it came from and when it was saved:
 *  - a different user signing in ignores it and gets their landing page;
 *  - after MAX_AGE_MS it is stale and ignored;
 *  - a page saved with no known user (a link opened while signed out, e.g.
 *    from an email) still applies to whoever signs in next, as before.
 */
const KEY = "post_login_redirect";
const META_KEY = "post_login_redirect_meta";
const MAX_AGE_MS = 12 * 60 * 60 * 1000;

const isRedirectable = (path) =>
  !!path &&
  path.startsWith("/") &&
  path !== "/" &&
  path !== "/login" &&
  !path.startsWith("/logout");

const currentUserId = () => {
  try {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
    const id = authUser?.get_staff_data?.Staff_Id;
    return id !== undefined && id !== null && id !== "" ? String(id) : null;
  } catch (_) {
    return null;
  }
};

export const savePostLoginRedirect = (path) => {
  try {
    if (!isRedirectable(path)) return;
    localStorage.setItem(KEY, path);
    localStorage.setItem(
      META_KEY,
      JSON.stringify({ userId: currentUserId(), savedAt: Date.now() })
    );
  } catch (_) {
    // ignore storage errors
  }
};

export const clearPostLoginRedirect = () => {
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem(META_KEY);
  } catch (_) {
    // ignore storage errors
  }
};

/**
 * The saved page if it should apply to the user now signing in, else null.
 * Does not clear it - the login saga clears it once it has navigated.
 */
export const readPostLoginRedirect = (signingInUserId) => {
  try {
    const path = localStorage.getItem(KEY);
    if (!isRedirectable(path)) return null;
    const meta = JSON.parse(localStorage.getItem(META_KEY) || "null");
    if (meta?.savedAt && Date.now() - Number(meta.savedAt) > MAX_AGE_MS) {
      return null;
    }
    if (
      meta?.userId &&
      signingInUserId !== undefined &&
      signingInUserId !== null &&
      String(meta.userId) !== String(signingInUserId)
    ) {
      return null;
    }
    return path;
  } catch (_) {
    return null;
  }
};
